<template>
    <b-input
        data-info="BaseBuefyInput Component"
        :value="value"
        @input="$emit('input', $event)"
        v-bind="$attrs"
        v-on="listenersWithoutInput"
        :aria-label="ariaLabel"
        :aria-labelledby="ariaLabelledby"
        :disabled="disabled"
        :tabindex="tabindex"
    />
</template>
  
<script>
import BaseInputMixin from "~/mixins/base-input";
export default {
    name: "BaseBuefyInput",
    inheritAttrs: false,
    mixins: [BaseInputMixin]
};
</script>
  